import reduce from 'lodash/reduce'
import { FeatureFlags, FeatureFlagsPayload } from '../../types'

const fromPayload = (payload: FeatureFlagsPayload): FeatureFlags =>
  // ensure all feature flags are booleans
  reduce(payload, (acc, value, key) => ({ ...acc, [key]: !!value }), {})

export default { fromPayload }
